import {
  Component,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BrowserModule } from '@angular/platform-browser';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { Color, ScaleType } from '@swimlane/ngx-charts';
// import { DateRange } from 'ngx-daterangepicker-material';

import * as moment from 'moment';
import { SwapStatus, convertNum } from 'src/app/shared/constants/app-enums';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from 'src/app/services/popup.service';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { environment } from 'src/environments/environment';
import { ClaimComponent } from 'src/app/modals/claim/claim.component';
import { ConnectComponent } from 'src/app/modals/connect/connect.component';
import { BuyStakeComponent } from 'src/app/modals/buy-stake/buy-stake.component';

@Component({
  selector: 'app-stake-dashboard',
  templateUrl: './stake-dashboard.component.html',
  styleUrls: ['./stake-dashboard.component.scss'],
})

export class StakeDashboardComponent implements AfterViewInit, OnInit, OnDestroy {
  modalRef?: BsModalRef;
  @ViewChild('graphCont') graphCont!: ElementRef;
  select2!: { startDate: moment.Moment; endDate: moment.Moment };
  select1!: { startDate: moment.Moment; endDate: moment.Moment };

  rewards = [
    {
      name: 'Aug-23',
      value: 50000000000,
    },
    {
      name: 'Sep-23',
      value: 50821250000,
    },
    {
      name: 'Oct-23',
      value: 51642500000,
    },
    {
      name: 'Nov-23',
      value: 52463750000,
    },
    {
      name: 'Dec-23',
      value: 53285000000,
    },
    {
      name: 'Jan-24',
      value: 54106250000,
    },
    {
      name: 'Feb-24',
      value: 54927500000,
    },
    {
      name: 'Mar-24',
      value: 55748750000,
    },
    {
      name: 'Apr-24',
      value: 56570000000,
    },
    {
      name: 'May-24',
      value: 57391250000,
    },
    {
      name: 'Jun-24',
      value: 58212500000,
    },
    {
      name: 'Jul-24',
      value: 59033750000,
    },
    {
      name: 'Aug-24',
      value: 59855000000,
    },
    {
      name: 'Sep-24',
      value: 60676250000,
    },
    {
      name: 'Oct-24',
      value: 61497500000,
    },
    {
      name: 'Nov-24',
      value: 62318750000,
    },
    {
      name: 'Dec-24',
      value: 63140000000,
    },
    {
      name: 'Jan-25',
      value: 63961250000,
    },
    {
      name: 'Feb-25',
      value: 64782500000,
    },
    {
      name: 'Mar-25',
      value: 65603750000,
    },
    {
      name: 'Apr-25',
      value: 66425000000,
    },
    {
      name: 'May-25',
      value: 67246250000,
    },
    {
      name: 'Jun-25',
      value: 68067500000,
    },
    {
      name: 'Jul-25',
      value: 68888750000,
    },
    {
      name: 'Aug-25',
      value: 69710000000,
    },
    {
      name: 'Sep-25',
      value: 70531250000,
    },
    {
      name: 'Oct-25',
      value: 71352500000,
    },
    {
      name: 'Nov-25',
      value: 72173750000,
    },
    {
      name: 'Dec-25',
      value: 72995000000,
    },
    {
      name: 'Jan-26',
      value: 73816250000,
    },
    {
      name: 'Feb-26',
      value: 74637500000,
    },
    {
      name: 'Mar-26',
      value: 75458750000,
    },
    {
      name: 'Apr-26',
      value: 76280000000,
    },
    {
      name: 'May-26',
      value: 77101250000,
    },
    {
      name: 'Jun-26',
      value: 77922500000,
    },
    {
      name: 'Jul-26',
      value: 78743750000,
    },
    {
      name: 'Aug-26',
      value: 79565000000,
    },
    {
      name: 'Sep-26',
      value: 80386250000,
    },
    {
      name: 'Oct-26',
      value: 81207500000,
    },
    {
      name: 'Nov-26',
      value: 82028750000,
    },
    {
      name: 'Dec-26',
      value: 82850000000,
    },
    {
      name: 'Jan-27',
      value: 83671250000,
    },
    {
      name: 'Feb-27',
      value: 84492500000,
    },
    {
      name: 'Mar-27',
      value: 85313750000,
    },
    {
      name: 'Apr-27',
      value: 86135000000,
    },
    {
      name: 'May-27',
      value: 86956250000,
    },
    {
      name: 'Jun-27',
      value: 87777500000,
    },
    {
      name: 'Jul-27',
      value: 88598750000,
    },
    {
      name: 'Aug-27',
      value: 89420000000,
    },
    {
      name: 'Sep-27',
      value: 90000000000,
    }
  ];
  fitContainer: boolean = true;
  view: [any, any] = [undefined, undefined];
  // view: [number, number] = [800, 400];
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  legendTitle: string = 'Total Rewards';
  legendPosition: string = 'below'; // ['right', 'below']
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = 'Months';
  showYAxisLabel = true;
  yAxisLabel = 'Rewards';
  SwapStatus = SwapStatus;
  showGridLines: boolean = true;
  showDataLabel: boolean = false;
  maxYAxis = 100;
  minYAxis = 0;
  stakeAmount!: number;
  colorScheme: Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
      '#A7A7A7',
    ],
  };
  refreshRate: number = 1000;
  lang: any = localStorage.getItem('currentlang');
  refreshId: any;
  timeInterval: any;

  // selectedDateRange: DateRange;
  onResize(event: any) {
    this.view = [+this.graphCont.nativeElement.offsetWidth / 1.05, 400];
  }


  constructor(
    private popupService: PopupService,
    private translate: TranslateService,
    private walletConnectService: WalletConnectService,
    private modalService: BsModalService
  ) {
    this.walletConnectService.activateSite();
    let year = 2023, month = 7, diff = 0;
    let date = new Date();
    let currMon = date.getUTCMonth();
    let currYear = date.getUTCFullYear();
    if (currYear > year) {
      diff = 12 - month + currMon + 12 * (currYear - year - 1);
    } else {
      diff = currMon - month;
    }
    this.colorScheme.domain[diff] = "#0067E5";
  }

  get stakeData() {
    return this.walletConnectService.stakeData;
  }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }

  get poolPercent() {
    return (this.walletAddress && this.stakeData.totalStaked !== 0) ? (+((this.stakeData.userStaked * 100 / this.stakeData.totalStaked).toFixed(5)) || 0) : 0;
  }

  checkEthChain() {
    if (!this.walletAddress) {
      this.connectModal();
      return false;
    }
    if (this.walletConnectService.isEthChain()) {
      return true;
    } else {
      this.popupService.messagePopup(
        "info",
        this.translate.instant('wrong_chain', { chainName: environment.eth.chainName }),
        this.translate.instant('change_network'))
        .then((res) => {
          if (res.isConfirmed) {
            this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
          }
        });
      return false;
    }
  }

  isCorrectChain() {
    return this.walletConnectService.isCorrectChain()
  }

  ngAfterViewInit() {
    this.view = [+this.graphCont.nativeElement.offsetWidth / 1.05, 400];
    console.log(this.view, 'view graph')
    setTimeout(() => {
      if (!this.walletAddress) {
        this.modalRef = this.modalService.show(ConnectComponent, {
          class: 'modal-min modal-dialog-centered',
          backdrop: 'static',
        });
      }
    }, 1000);
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }

  openClaimStake(): void {
    setTimeout(() => {
      if (!this.walletAddress) {
        this.modalService.show(ConnectComponent, {
          class: 'modal-xs modal-dialog-centered',
          backdrop: 'static',
        });
        this.timeInterval = setInterval(() => this.startConnectInterval(), 2000);
      } else if (this.walletAddress && this.ethPurchased == 0) {
        this.modalRef = this.modalService.show(BuyStakeComponent, {
          class: 'modal-xs modal-dialog-centered',
          backdrop: 'static',
        });
      }
    }, 500);
  }

  startConnectInterval() {
    if (this.walletAddress) {
      if(this.ethPurchased == 0){
        this.modalRef = this.modalService.show(BuyStakeComponent, {
          class: 'modal-xs modal-dialog-centered',
          backdrop: 'static',
        });
      }
      clearInterval(this.timeInterval);
    }
  }

  claimStake(): void {
    if (this.ethPurchased == 0 || !this.checkEthChain())
      return;
    this.walletConnectService.claimStake();
    this.modalRef = this.modalService.show(ClaimComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
      initialState: { isStake: true }
    });
  }

  closeModal() {
    this.modalRef!.hide();
  }

  ngOnInit(): void { }
  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value: any) {
    return this.formatNumber(value); // this is where you can change the formatting
  }
  onSelect(event: any) {
    console.log(event);
  }

  onActivate(data: any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data: any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  formatString(input: string): string {
    return input.toUpperCase();
  }

  formatNumber(input: number) {
    return convertNum(input);
  }

  get userReward() {
    return this.walletAddress ? this.formatNumber(+this.stakeData.userReward.toFixed(0)) : 0;
  }

  get status() {
    // return this.SwapStatus.rejected;
    return this.walletConnectService.swapStatus;
  }

  get userStaked() {
    return this.walletAddress ? this.formatNumber(+this.stakeData.userStaked.toFixed(0)) : 0;
  }

  get ethPurchased() {
    return this.walletAddress ? this.formatNumber(this.ethTokens!) : 0;
  }

  get ethTokens() {
    return this.walletAddress ? this.walletConnectService.balanceData.ethClaimable : 0;
  }

  get totalStaked() {
    return this.formatNumber(+this.stakeData.totalStaked.toFixed(0));
  }

  get userBal() {
    return this.formatNumber(this.stakeData.userBal);
  }

  get unstakeDate() {
    return new Date(this.stakeData.unlockTime * 1000);
  }

  get canUnstake() {
    return new Date(this.stakeData.unlockTime * 1000) < new Date();
  }

  withdrawStake(): void {
    if (this.stakeData.userStaked == 0 || !this.checkEthChain())
      return;
    this.walletConnectService.withdrawStake();
    this.modalRef!.hide();
    setTimeout(() => {

      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { isWithdraw: true }
      });
    }, 500)
  }

  claim(): void {
    if (!this.stakeData.isClaimEnabled) {
      this.popupService.messagePopup(
        "info",
        this.translate.instant('claim_not_live'));
      return;
    }
    if (this.stakeData.userReward == 0 || !this.checkEthChain())
      return;
    this.walletConnectService.claimStakeRewards();
    this.modalRef?.hide();
    setTimeout(() => {

      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
      });
    }, 500)
  }

  max() {
    this.stakeAmount = this.stakeData.userBal;
  }

  stakeToken(template: TemplateRef<any>): void {
    if (!this.checkEthChain() || (this.stakeAmount > this.stakeData.userBal))
      return;
    this.walletConnectService.createStake(this.stakeAmount);
    this.modalRef!.hide();
    setTimeout(() => {
      this.modalRef = this.modalService.show(template, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
      });
    }, 1000)
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static'
    });
  }

  poolInfo() {
    this.popupService.messagePopup(
      "info",
      this.translate.instant('pool_share'));
  }

  get cryptoName() {
    return environment.tokenName;
  }

  get hash() {
    return this.walletConnectService.swapHash;
  }

  viewUrl() {
    const blkUrl = environment.eth.blockExplorerURL
    window.open(blkUrl + this.hash, '_blank');
  }

  ngOnDestroy(): void {
    clearInterval(this.timeInterval);
  }
}
